<template>
  <page-content
    :has-sticky-col-left="true"
    :has-left-col-small="true"
    :has-padd-right-normal="false"
    :has-padd-left-normal="false"
    :has-padd-right-on-act="false"
    :has-padd-left-on-act="false"
    :set-left-col-class="'is-narrow is-maxW300p is-minW300p is-margin-right-less is-marginless-right has-background-white is-border-right'"
    :has-left-col-collapse="true"
    :opened-col="true">
    <template slot="left-col-small">
      <div class="field is-marginless">
        <div class="control">
          <div class="has-flatpickr-responsive has-flatpickr-theme--s1 has-flatpickr-padding-h has-background-white-ter is-border-bottom is-padding-bottom-small">
            <flat-pickr
              :config="configList"
              id="flatpickr"
              class="input is-hidden is-radiusless is-shadowless flatpickr-input is-noDecalPosTop"
              name="date"
              @on-change="inputRangeDate"
              v-model="range_date"></flat-pickr>
          </div>
        </div>
      </div>
      <div>
        <div
          v-if="hasFilter"
          class="is-padding-left is-padding-top-xxsmall is-padding-bottom-xxsmall is-border-top has-background-annonce">
          <a
            class="has-text-white is-size-6"
            @click.prevent.stop="resetFiltersCalendarList">
            <span class="icon"><i class="fas fa-undo"></i></span>
            <span class="is-italic">Réinitialiser tous les filtres</span>
          </a>
        </div>
        <div
          v-if="panel === 'rdvs'"
          class="is-padding-top-small is-padding-left is-padding-right">
          <r-label
            :label="'Filtrage par critères :'"
            :is-required="false"></r-label>
          <div class="field is-grouped">
            <div
              v-for="type in rdvTypeList"
              :key="type.value"
              class="control is-expanded">
              <input
                :id="type.value"
                v-model="filters.rdv_type"
                :value="type.label"
                name="typeRdv"
                :class="{'is-active' : filters.rdv_type.map(x=> x.value).includes(type.value)}"
                checked="checked"
                class="vadCheckradiocase is-primary is-fullwidth"
                type="checkbox"
                @change="updateSimpleFilter(); focus(`#${type.value}`)">
              <label :for="type.value">{{ type.label }}</label>
            </div>
          </div>
        </div>
        <div
          v-if="panel === 'rdvs'"
          class="is-padding-top-small is-padding-left is-padding-right">
          <div class="control is-expanded">
            <input
              id="unqualified"
              v-model="unqualified"
              name="typeRdv"
              :class="{'is-active' : unqualified }"
              checked="checked"
              class="vadCheckradiocase is-primary is-fullwidth"
              type="checkbox"
              @click="updateUnqualified(); focus(`#unqualified`)">
            <label for="unqualified">Voir les rendez-vous non qualifiés</label>
          </div>
        </div>
        <div
          v-if="isAdmin || isManager"
          class="is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <div
              @click="openUserSelection('author')"
              class="input">
              <div v-if="filters.author && filters.author.length">
                <span class="">Organisateurs ({{ filters.author.length }})</span>
              </div>
              <span
                v-else
                class="has-text-grey">Sélectionner organisateur</span>
            </div>
          </div>
        </div>
        <div
          v-if="panel === 'rdvs'"
          class="is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <div
              @click="openContactSelection()"
              class="input">
              <div v-if="filters.contact && filters.contact.length">
                <span class="">contacts ({{ filters.contact.length }})</span>
              </div>
              <span
                v-else
                class="has-text-grey">Rechercher contact</span>
            </div>
          </div>
        </div>
        <div
          v-if="panel === 'rdvs' && (isAdmin || isManager)"
          class="is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <div
              @click="openUserSelection('user')"
              class="input">
              <div v-if="filters.user && filters.user.length">
                <span class="">Participants ({{ filters.user.length }})</span>
              </div>
              <span
                v-else
                class="has-text-grey">Rechercher participant</span>
            </div>
          </div>
        </div>
        <!-- <div class="field is-padding-left is-padding-right is-padding-top-small">
          <r-label
            :label="'Filtrage par date :'"
            :is-required="false"></r-label>
          <div class="control">
            <date-picker
              :model="{date__gte: filters.date__gte, date__lte: filters.date__lte}"
              :style-version="2"
              :is-range="true"
              :name="'date'"
              :placeholder="'Date'"
              :config="{mode: 'range'}"
              @input="Object.assign(filters, $event); updateSimpleFilter()" />
          </div>
        </div> -->
        <!-- <div
          v-if="(isAdmin && isPromoteur) || currentUser.active_all_contact"
          class="field is-padding-left is-padding-right is-padding-top-small">
          <div class="control">
            <multiselect
              @input="updateSimpleFilter"
              @open="!programsFilter.length ? getAgenceByName() : null"
              :loading="loadingFilters === 'agence'"
              v-model="filters.agence"
              label="name"
              track-by="pk"
              class="multiselect--option-ico is-single_choice"
              open-direction="bottom"
              :multiple="true"
              :options="agencesFilter"
              :searchable="true"
              :close-on-select="false"
              :show-labels="false"
              :placeholder="''">
              <span slot="noResult">Oups! Aucune agence trouvée.</span>
              <span
                slot="placeholder"
                class="multiselect__placeholder">Agences</span>
              <span
                slot="selection"
                class="multiselect__placeholder"
                slot-scope="{ values }"
                v-if="values.length">
                <span>Agences ({{ values.length }})</span>
              </span>
              <span slot="noOptions">La liste est vide</span>
            </multiselect>
          </div>
        </div> -->
      </div>
    </template>

    <template>
      <div>
        <tabs
          class="has-background-white is-border-bottom"
          :niveau="1">
          <li :class="{'is-active' : panel === 'rdvs'}">
            <a
              @click="changePanel('rdvs')"
              class="">
              <span class="">Rendez-vous</span>
            </a>
          </li>
          <li :class="{'is-active' : panel === 'reminders'}">
            <a
              @click="changePanel('reminders')"
              class="">
              <span class="">Rappel</span>
            </a>
          </li>
          <li :class="{'is-active' : panel === 'options'}">
            <a
              @click="changePanel('options')"
              class="">
              <span class="">fin d'option</span>
            </a>
          </li>
        </tabs>
        <div
          class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-border-bottom"
          v-show="panel == 'rdvs'">
          <div class="field is-grouped">
            <p
              class="control"
              v-for="status in qualifications"
              :key="status.value">
              <label
                class="checkbox checkRadioIsHide"
                :for="status.value">
                <input
                  :id="status.value"
                  :name="status.name"
                  type="checkbox"
                  :value="status.value"
                  @click="updateSimpleFilter"
                  v-model="filters.status">
                <span
                  class="tag"
                  :class="status.color">
                  <span>{{ status.label }}</span><span class="icon"><i
                    class="far"
                    :class="filters.status.includes(status.value) ? 'fa-check-square' : 'fa-square'"></i></span>
                </span>
              </label>
            </p>
          </div>
        </div>
        <div v-if="!loading">
          <filters-tags
            id="user-tag"
            :has-filter="hasFilter"
            :filters="filters"
            @reset="resetFiltersCalendarList"
            @update="updateFromTag($event)"></filters-tags>
          <rdv-list
            v-if="panel === 'rdvs' && !loading"
            :items="items"
            :has-filter="hasFilter"
            :current-page="currentPage"
            :total-page="totalPage"
            @resetFilters="resetFiltersCalendarList"
            @loadItems="loadItems"></rdv-list>
          <reminder-list
            v-if="panel === 'reminders' && !loading"
            :items="items"
            :has-filter="hasFilter"
            :current-page="currentPage"
            :total-page="totalPage"
            @resetFilters="resetFiltersCalendarList"
            @loadItems="loadItems"></reminder-list>
          <options-calendar-list
            v-if="panel === 'options' && !loading"
            :items="items"
            :has-filter="hasFilter"
            :current-page="currentPage"
            :total-page="totalPage"
            @resetFilters="resetFiltersCalendarList"
            @loadItems="loadItems"></options-calendar-list>
        </div>
        <spinner-round
          :is-loading="loading"
          v-else-if="loading"></spinner-round>
      </div>
    </template>
  </page-content>
</template>

<script>
import { Calendar, Filter, Quickview, GenericList, Sort, DefaultValues, FilterGetter } from '@/mixins'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'CalendarList',
  components: {
    RdvList: () => import('@/components/calendar/RdvList'),
    ReminderList: () => import('@/components/calendar/ReminderList'),
    OptionsCalendarList: () => import('@/components/calendar/OptionsCalendarList')
  },
  mixins: [Calendar, Filter, Quickview, GenericList, Sort, DefaultValues, FilterGetter],
  data () {
    return {
      blockByUnqualified: false,
      unqualified: false,
      blockPickr: false,
      canInitRange: true,
      loadDocuments: this.loadItems,
      panel: 'rdvs',
      items: [],
      range_date: moment().format('DD/MM/YYYY'),
      init_range_date: moment().format('DD/MM/YYYY'),
      configList: {
        mode: 'range',
        inline: true,
        enableTime: false,
        noCalendar: false,
        dateFormat: 'd/m/Y',
        time_24hr: true
      },
      agenceFilter: []
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isSeller', 'isManager', 'isPromoteur', 'calendarRdv']),
    service () {
      if (this.panel === 'rdvs') {
        return 'RDV'
      } else if (this.panel === 'reminders') {
        return 'REMINDER'
      } else if (this.panel === 'options') {
        return 'OPTION'
      } else {
        return ''
      }
    }
  },
  watch: {
    'filters.status' (v) {
      if (!v.includes('new') && this.unqualified) {
        this.unqualified = false
        this.initRangeDate()
      }
    },
    service (v) {
      if (v) {
        this.canInitRange = false
        if (this.range_date === this.init_range_date) {
          this.initRangeDate()
        } else {
          if (this.panel === 'options') {
            this.filters.status = ['waiting_list', 'approved']
          }
          this.loadItems()
        }
      }
    },
    sentDate () {
      let elem = [this.sentDate, this.sentDate]
      this.changeRangeDate(elem)
    },
    items (items) {
      let programedActions = items.length
      if (this.panel === 'rdvs') {
        this.$store.commit('setCalendarRdvProgramedActions', { programedActions })
        this.$store.commit('setCalendarReminderProgramedActions', { programedActions: 0 })
        this.$store.commit('setCalendarOptionProgramedActions', { programedActions: 0 })
      } else if (this.panel === 'reminders') {
        this.$store.commit('setCalendarReminderProgramedActions', { programedActions })
        this.$store.commit('setCalendarRdvProgramedActions', { programedActions: 0 })
        this.$store.commit('setCalendarOptionProgramedActions', { programedActions: 0 })
      } else {
        this.$store.commit('setCalendarOptionProgramedActions', { programedActions })
        this.$store.commit('setCalendarReminderProgramedActions', { programedActions: 0 })
        this.$store.commit('setCalendarRdvProgramedActions', { programedActions: 0 })
      }

      if (this.canInitRange) {
        this.canInitRange = false
        this.initRangeDate()
      }
    },
    panel (newVal, oldVal) {
      if (newVal === 'rdvs' || newVal === 'reminders') {
        this.resetFiltersCalendarList()
      }
    }
  },
  created () {
    if ('unqualified' in this.$route.params && this.$route.params.unqualified) {
      this.blockByUnqualified = true
      this.canInitRange = false
      this.unqualified = this.$route.params.unqualified
      this.updateUnqualified()
      if (this.isAdmin || this.isManager) {
        this.filters.user = [this.currentUser]
      }
    }
    if ('panel' in this.$route.params && this.$route.params.panel && this.$route.params.panel !== this.panel) {
      this.changePanel(this.$route.params.panel)
    }
  },
  methods: {
    beforeGet () {
      this.query.account = this.currentUser.account.pk
    },
    changePanel (panel) {
      this.panel = panel
      this.initRangeDate()
    },
    async resetFiltersCalendarList () {
      this.unqualified = false
      this.query = cloneDeep(this.initFilters)
      this.filters = cloneDeep(this.initFilters)
      this.initRangeDate()
    },
    async inputRangeDate (date) {
      if (this.blockPickr) return
      if (date.length <= 1) return
      let startRangeDate = moment(date[0]).startOf('day').toISOString()
      let endRangeDate = moment(date[1]).endOf('day').toISOString()
      await this.$set(this.filters, 'date__lte', endRangeDate)
      await this.$set(this.filters, 'date__gte', startRangeDate)
      await this.updateSimpleFilter()
    },
    async changeRangeDate (date) {
      if (this.blockPickr) return
      let startRangeDate = moment(date[0]).startOf('month').startOf('day').toISOString()
      let endRangeDate = moment(date[1]).endOf('month').endOf('day').toISOString()
      await this.$set(this.filters, 'date__lte', endRangeDate)
      await this.$set(this.filters, 'date__gte', startRangeDate)
      this.range_date = `${moment(startRangeDate).format('DD/MM/YYYY')} au ${moment(endRangeDate).format('DD/MM/YYYY')}`
      await this.updateSimpleFilter()
    },
    async initRangeDate () {
      if (this.blockByUnqualified) return
      this.loading = true
      let params = {
        date__gte: moment(this.today).startOf('day').toISOString(),
        per_page: 1,
        sort: 'date:desc'
      }
      let request
      if (this.panel === 'rdvs') {
        request = await this.$api.get(this.$resources.RDV, params)
      } else if (this.panel === 'reminders') {
        request = await this.$api.get(this.$resources.REMINDER, params)
      } else if (this.panel === 'options') {
        request = await this.$api.get(this.$resources.OPTION, params)
      }
      let startRangeDate = moment(this.today).startOf('day').toISOString()
      let endRangeDate
      if (request.data.items.length && request.data.items[0]) {
        endRangeDate = moment(request.data.items[0].date).endOf('day').toISOString()
        await this.$set(this.initFilters, 'date__lte', endRangeDate)
        await this.$set(this.initFilters, 'date__gte', startRangeDate)
        await this.$set(this.filters, 'date__lte', endRangeDate)
        await this.$set(this.filters, 'date__gte', startRangeDate)
        this.range_date = `${moment(startRangeDate).format('DD/MM/YYYY')} au ${moment(endRangeDate).format('DD/MM/YYYY')}`
        this.init_range_date = `${moment(startRangeDate).format('DD/MM/YYYY')} au ${moment(endRangeDate).format('DD/MM/YYYY')}`
        await this.updateSimpleFilter()
      } else {
        this.blockPickr = true
        endRangeDate = moment(this.today).endOf('day').toISOString()
        this.range_date = `${moment(startRangeDate).format('DD/MM/YYYY')} au ${moment(endRangeDate).format('DD/MM/YYYY')}`
        this.init_range_date = `${moment(startRangeDate).format('DD/MM/YYYY')} au ${moment(endRangeDate).format('DD/MM/YYYY')}`
        await this.$set(this.initFilters, 'date__gte', startRangeDate)
        await this.$set(this.filters, 'date__gte', startRangeDate)
        await this.updateSimpleFilter()
        this.blockPickr = false
      }
    },
    async initUnqualifiedRangeDate () {
      this.loading = true
      let params = {
        date__lte: moment(this.today).endOf('day').toISOString(),
        per_page: 1,
        status: 'new',
        sort: 'date:asc'
      }
      let { data } = await this.$api.get(this.$resources.RDV, params)
      let endRangeDate = moment(this.today).endOf('day').toISOString()
      let startRangeDate
      if (data.items.length && data.items[0]) {
        startRangeDate = moment(data.items[0].date).startOf('day').toISOString()
        await this.$set(this.initFilters, 'date__lte', endRangeDate)
        await this.$set(this.initFilters, 'date__gte', startRangeDate)
        await this.$set(this.filters, 'date__lte', endRangeDate)
        await this.$set(this.filters, 'date__gte', startRangeDate)
        this.range_date = `${moment(startRangeDate).format('DD/MM/YYYY')} au ${moment(endRangeDate).format('DD/MM/YYYY')}`
        this.init_range_date = `${moment(startRangeDate).format('DD/MM/YYYY')} au ${moment(endRangeDate).format('DD/MM/YYYY')}`
        await this.updateSimpleFilter()
      } else {
        this.blockPickr = true
        endRangeDate = moment(this.today).endOf('day').toISOString()
        this.range_date = `${moment(startRangeDate).format('DD/MM/YYYY')} au ${moment(endRangeDate).format('DD/MM/YYYY')}`
        this.init_range_date = `${moment(startRangeDate).format('DD/MM/YYYY')} au ${moment(endRangeDate).format('DD/MM/YYYY')}`
        await this.$set(this.initFilters, 'date__gte', startRangeDate)
        await this.$set(this.filters, 'date__gte', startRangeDate)
        await this.updateSimpleFilter()
        this.blockPickr = false
      }
      this.blockByUnqualified = false
    }
  }
}
</script>
